import { render, staticRenderFns } from "./addRoleDialog.vue?vue&type=template&id=77c4d6c6"
import script from "./addRoleDialog.vue?vue&type=script&lang=js"
export * from "./addRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./addRoleDialog.vue?vue&type=style&index=0&id=77c4d6c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports